import React from "react";
import Toranj from '../assets/Toranj.png';
import "./AboutUs.css";
import video from '../assets/toranj.mp4'; // Import the video file


const AboutUs = () => {
  return (
    <div className="responsive-container-block bigContainer">
      <div className="responsive-container-block Container">
      
        <div className="responsive-container-block textSide">
          <p className="text-blk heading">Chemistry Tutor at FutureMedsAcademy</p>
          {/* <h2>My Journey and the Vision Behind Future MedsAcademy</h2> */}
          <p className="text-blk subHeading">
          Toranj Maleki, a dedicated medical student in Italy, is highly regarded for her
expertise in physical chemistry and stoichiometry. With an IMAT score of

72.8, she has established herself as a skilled mentor, known for her concept-
driven teaching approach, especially in chemistry.

Her strong grasp of fundamental principles and ability to simplify complex
topics make her an invaluable resource for students preparing for the IMAT
exam. Over the past two years, Toranj has been committed to mentoring
aspiring medical students, helping them navigate the challenges of IMAT

chemistry with confidence and clarity.
          </p>
          {/* {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12"
            >
              <div className="cardImgContainer">
                <img
                  className="cardImg"
                  src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/id2.svg"
                  alt="Value Icon"
                />
              </div>
              <div className="cardText">
                <p className="text-blk cardHeading">Value</p>
                <p className="text-blk cardSubHeading">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </div>
            </div>
          ))}
          <a href="#">
            <button className="explore">Read more</button>
          </a> */}
        </div>

        <div className="imgContainer">
          <img
            className="blueDots"
            src="https://workik-widget-assets.s3.amazonaws.com/widget-assets/images/aw3.svg"
            alt="background dots"
          />
          <img
            className="mainImg"
            src={Toranj}
            alt="Main"
          />
                <h1>Toranj Maleki</h1>

               
        </div>
        <video
                            className="mainVideo"
                            controls
                            autoPlay
                            loop
                            src={video}
                            alt="Video"
                          />

      
      </div>
    </div>
     );
    };
    
    export default AboutUs;